/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Memoized wrapper for LazySection
 */

import { createAllowedPropsAreEqual } from '@zcode/react-utils'
import React from 'react'

import { LazySection, LazySectionProps } from './LazySection'

const equalProps = [
  'as',
  'component',
  'fallback',
  'forceInView',
  'lazySectionClassName',
  'root',
  'rootMargin',
] as const
const shallowEqualProps = [
  'fallbackStyle',
  'forwardProps',
  'threshold',
] as const
const areEqual = createAllowedPropsAreEqual<LazySectionProps<any>>(
  equalProps,
  shallowEqualProps
)

export const MemoLazySection = React.memo(
  LazySection,
  areEqual
) as typeof LazySection
